export const ROLE_LEVEL = { GATEWAY_ADMIN: 3, CLIENT_ADMIN: 2, USER: 1 };

// Perfis visíveis para filtragem/listagem na tabela de utilizadores (UserList.js) —
// controlo de quem o utilizador actual pode VER, não relacionado com convites.
export const VISIBLE_PROFILES = {
  GATEWAY_ADMIN: ['GATEWAY_ADMIN', 'CLIENT_ADMIN', 'USER'],
  CLIENT_ADMIN: ['CLIENT_ADMIN', 'USER'],
  USER: ['CLIENT_ADMIN', 'USER'],
};

// Perfis atribuíveis por quem convida (currentUserRole) e tipo de convite (inviteType).
// Ver rnd-backend-framework/docs/superpowers/specs/2026-07-08-invite-dialog-redesign-design.md secção 4.
const INVITE_PROFILE_MATRIX = {
  GATEWAY_ADMIN: {
    entra: ['GATEWAY_ADMIN', 'CLIENT_ADMIN'],
    local: ['CLIENT_ADMIN', 'USER'],
  },
  CLIENT_ADMIN: {
    local: ['CLIENT_ADMIN', 'USER'],
  },
};

export const getInvitableProfileCodes = (currentUserRole, inviteType) =>
  INVITE_PROFILE_MATRIX[currentUserRole]?.[inviteType] ?? [];

export const isEntraAuthProvider = (authProvider) =>
  Boolean(
    authProvider &&
      ['ENTRA', 'AZUREAD', 'AZURE_AD'].includes(String(authProvider).trim().toUpperCase())
  );

// Perfis atribuíveis na alteração de permissões ("Gerir Permissões" em UserList.js).
// Regra de segurança: Apenas um Administrador Gateway autenticado via Entra ID pode atribuir
// GATEWAY_ADMIN, e APENAS a utilizadores que possuam conta Entra ID.
export const getAssignableProfileCodes = (callerRole, targetAuthProvider, callerAuthProvider = 'ENTRA') => {
  const isCallerEntra = isEntraAuthProvider(callerAuthProvider);
  const isTargetEntra = isEntraAuthProvider(targetAuthProvider);

  if (callerRole === 'GATEWAY_ADMIN') {
    if (!isCallerEntra) {
      return ['CLIENT_ADMIN', 'USER'];
    }
    return isTargetEntra
      ? ['GATEWAY_ADMIN', 'CLIENT_ADMIN', 'USER']
      : ['CLIENT_ADMIN', 'USER'];
  }

  if (callerRole === 'CLIENT_ADMIN') {
    return ['USER'];
  }

  return ['USER'];
};

// Categorias de alerta disponíveis por perfil — usado no convite (perfil recém-atribuído)
// e na edição de utilizador existente (EditUserDialog em UserList.js).
export const NOTIF_CATEGORIES = {
  GATEWAY_ADMIN: ['INGESTION_ERRORS', 'DEVICE_ERRORS', 'APPLICATION_ERRORS'],
  CLIENT_ADMIN: ['DEVICE_ERRORS'],
};
